import { useState, useEffect } from "react";

// useState che sopravvive all'uscita dalla pagina: serve a ritrovare filtri e
// ricerca quando si torna indietro da una scheda. sessionStorage e non
// localStorage, così una nuova scheda del browser riparte da una lista pulita.
// Il try/catch copre la navigazione privata, dove lo storage può lanciare.
export default function useStatoSessione(chiave, valoreIniziale) {
  const [valore, setValore] = useState(() => {
    try {
      const salvato = sessionStorage.getItem(chiave);
      return salvato !== null ? JSON.parse(salvato) : valoreIniziale;
    } catch {
      return valoreIniziale;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(chiave, JSON.stringify(valore));
    } catch {
      // Storage pieno o non disponibile: lo stato resta valido in memoria.
    }
  }, [chiave, valore]);

  return [valore, setValore];
}
